import axios from "axios";
import qs from "qs";
import { COU_CheckValidation } from "./co_util";
import {
  Service_GetZfbMemberToken,
  Service_GetGroupIdByLocal,
} from "@/service/platform_config";
import { COU_IsDevOrTest } from "@/utils/co_util";
const http_request = axios.create({
  headers: { "Content-type": "application/x-www-form-urlencoded" },
});
const http_request2 = axios.create({
  headers: { "Content-type": "application/x-www-form-urlencoded" },
});
const isHttps = window.location.protocol.includes("https");
const url = `${isHttps ? "https" : "http"}://api-fuwu.zzbtool.com/xf/alipay`;
const url2 = `${isHttps ? "https" : "http"}://api.xfdy.zzbtool.com`;
const testUrl = "https://api-fuwu.zzbtool.com/xf/alipay";
http_request.defaults.baseURL =
  (COU_IsDevOrTest() ? testUrl : url) + "/alipayApi";
http_request2.defaults.baseURL = url2; //单独给查后台配置的接口
export function COU_httpGet2({ url, header = {}, data }) {
  return new Promise((resolve, reject) => {
    http_request2
      .get(url, {
        headers: header,
        params: data,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
export function COU_httpGet({ url, header = {}, data }) {
  return new Promise((resolve, reject) => {
    http_request
      .get(url, {
        headers: header,
        params: data,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function COU_httpPost({ url, header = {}, data }) {
  return new Promise((resolve, reject) => {
    if (!header || !header["Content-type"]) data = qs.stringify(data);
    http_request
      .post(url, data, { headers: header })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

// 请求拦截
http_request.interceptors.request.use(
  (req) => {
    const token = Service_GetZfbMemberToken();
    if (token) req.headers.token = token;
    if (!req.url.includes("currentGroupId"))
      req.url += `${
        req.url.includes("?") ? "&" : "?"
      }currentGroupId=${Service_GetGroupIdByLocal()}`;
    return req;
  },
  (err) => {
    console.log("错误信息 (请求时发生)。。。。。。。。", err);
    return Promise.reject(err);
  }
);

// 授权弹出框只弹一次
let initDouyinAuth = true;
// 响应拦截器 如果授权过期那么跳回服务市场
http_request.interceptors.response.use(
  async (response) => {
    const { code, result, msg } = response.data;
    // code=2000专门是指1688授权的
    if (
      [20000, 2000, 20004].includes(code) &&
      initDouyinAuth &&
      msg.indexOf("无限") < 0
    ) {
      initDouyinAuth = false;
      let btnName = `去${msg?.includes("购买") ? "购买" : "授权"}`,
        authUrl = "",
        str = "";
      if (result?.ClickUrl) {
        authUrl = result.ClickUrl;
        str = msg;
        await COU_CheckValidation(authUrl, {
          content1: str,
          okText1: btnName,
          content2: "如已确认完成操作，请点击【确定】按钮",
          okFn: () => window.location.reload(),
          cancelFn: () => (initDouyinAuth = true),
        });
      } else {
        console.log("相应拦截...", code, result, msg);
      }
    }
    return response;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
